import { ui } from '@procuros/datachecks';

import { useErrorContext } from 'contexts/ErrorsNavigationContext/ErrorsNavigationContext';
import { WebEDIError } from 'services/webediErrors/types';

import { MessageNonFieldErrorBanner } from '../MessageNonFieldErrorBanner/MessageNonFieldErrorBanner';

export const DocumentSectionError = ({
  path,
  sectionConfig,
}: {
  path: string;
  sectionConfig: Pick<ui.Section, 'description'>;
}) => {
  const { service } = useErrorContext<WebEDIError>();
  const error = service.useErrorById(path);
  const numberOfErrors = service.useNumberOfActiveErrors();
  const setCurrentError = service.setCurrentError;

  if (!error) {
    return null;
  }

  return (
    <MessageNonFieldErrorBanner
      error={error}
      totalNumberOfErrors={numberOfErrors}
      setCurrentError={setCurrentError}
      sectionDescription={sectionConfig.description}
    />
  );
};
